import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';
// import dropdownArrow from '@/assets/icon/dropdown-arrow-grey.svg';
import dropdownArrow from '@/assets/icon/dropdown-arrow.svg';
import imgUser from '@/assets/icon/img-user.svg';
import logoutIcon from '@/assets/icon/logout-icon.svg';
import useAuth from '@/domains/auth/hooks/useAuth';
import ModalProfileManagement from '@/domains/profile-management/components/ModalProfileManagement/ModalProfileManagement';
import { cn } from '@/lib/utils';
import NoticeMessage from '@/plugin/noticemessage/noticemessage';
import ThemeToggle from '@/shared/components/ui/ThemeToggle/ThemeToggle';
import { URLS } from '@/shared/config/urls';
import i18n from '@/shared/utils/i18n';
import Common from '@/shared/utils/standard';
import classes from './Sidebar.module.css';
import type { SidebarProps } from './Sidebar.types';

const Sidebar = ({
  userInfo,
  commonData,
  navbarList,
  preferenceData,
}: SidebarProps): JSX.Element => {
  const { t } = useTranslation();
  const { handleLogout } = useAuth();
  const [time, setTime] = useState('');
  const [date, setDate] = useState('');
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [language, setLanguage] = useState('');

  useEffect(() => {
    const langSource = Common.getDTPLangSource(i18n.language as 'kor' | 'eng' | 'ind');
    setLanguage(i18n.language.toLocaleUpperCase());
    const updateDateTime = () => {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');

      const dayName = langSource?.days[now.getDay()] ?? '';
      const monthName = langSource?.months[now.getMonth()] ?? '';
      const day = now.getDate();
      const year = now.getFullYear();

      setTime(`${hours}:${minutes}:${seconds}`);
      setDate(`${dayName}, ${monthName} ${day} ${year}`);
    };

    updateDateTime();
    const intervalId = setInterval(updateDateTime, 1000);

    return () => clearInterval(intervalId);
  }, []);

  // const categories = [
  //   { name: "dashboard", label: "Dashboard", path: "/dashboard/main-dashboard" },
  //   { name: "system", label: '시스템 관리' },
  //   { name: "asset", label: '자산 관리' },
  //   { name: "site", label: "사이트 관리" },
  //   { name: "statistic", label: "통계" },
  // ]

  const programOrder = [
    'DASHBOARD',
    'SYSTEM',
    'ASSET',
    'SITE-MANAGEMENT',
    'STATISTICS',
    'SCENARIO',
    'LOG',
  ];

  const categories = navbarList

    ?.sort((a, b) => {
      const indexA = programOrder.indexOf(a.program_id);
      const indexB = programOrder.indexOf(b.program_id);

      // programOrder에 없는 항목은 -1 → Infinity로 변환하여 뒤로 보냄
      const orderA = indexA === -1 ? Infinity : indexA;
      const orderB = indexB === -1 ? Infinity : indexB;

      return orderA - orderB;
    })
    ?.map((item) => ({
      name: item.program_id,
      label: item.lang,
      path: item.url || item.urls?.[0],
    }));

  const links = navbarList?.flatMap(
    (item) =>
      item.child_program_ids?.map((childId, index) => ({
        id: childId,
        label: item.langs?.[index],
        path: item.urls?.[index],
        category: item.program_id,
      })) ?? []
  );
  console.log('categories', categories);
  console.log('links', links);
  // const links = [
  //   // {id: "main-dashboard", label: "Main dashboard", path: "/dashboard/main-dashboard", category: "dashboard"},
  //   // {id: "crossroad", label: "Cross Road", path: "/dashboard/crossroad", category: "dashboard"},
  //   // {id: "equipment-info", label: "Equipment-info", path: "/dashboard/equipment-info", category: "dashboard"},
  //   // {id: "accessroad", label: "Access Road", path: "/dashboard/accessroad", category: "dashboard"},
  //   // {id: "crosswalk", label: "Cross Walk", path: "/dashboard/crosswalk", category: "dashboard"},

  //   { id: "code", label: '코드 관리', path: "/system-management/code", category: "system", },
  //   { id: "group", label: '그룹 관리', path: "/system-management/group", category: "system", },
  //   { id: "user", label: '유저 관리', path: "/system-management/user", category: "system", },
  //   { id: "program", label: '프로그램 관리', path: "/system-management/program", category: "system", },
  //   { id: "authority", label: '권한 관리', path: "/system-management/authority", category: "system", },

  //   {id: "box", label: '함체', path: "/asset-management/box", category: "asset"},
  //   {id: "detector", label: '검지기', path: "/asset-management/detector", category: "asset"},
  //   {id: "facility", label: '시설물', path: "/asset-management/facility", category: "asset"},

  //   {id: "site", label: "사이트", path: "/site-management/site", category: "site"},

  //   {id: "communication-history", label: "소통정보 이력", path: "/statistic/communication-history", category: "statistic"},
  //   {id: "communication-statistic", label: "소통정보 통계", path: "/statistic/communication-statistic", category: "statistic"},
  //   {id: "sudden-event", label: "돌발이벤트", path: "/statistic/sudden-event", category: "statistic"}
  // ];

  const [openMenu, setOpenMenu] = useState('');
  const [isLinksReady, setIsLinksReady] = useState(false);
  const linksRef = useRef<
    { id: string; label: string | undefined; path: string | undefined; category: string }[]
  >([]);

  const toggleVisibility = (menu: string) => {
    setOpenMenu((prevMenu) => (prevMenu === menu ? '' : menu));
  };

  // const toggleVisibility = () => {
  //   setIsVisible((prev) => !prev);
  // };
  const isLinkActive = (linkPath: string) => {
    return location.pathname.includes(linkPath);
  };

  const handleLogoutButton = () => {
    // TODO: Replace NoticeMessage with React-based toast/snackbar pattern
    const checkLogout = new NoticeMessage(t('msg > logout confirm'), {
      mode: 'confirm',
    });

    checkLogout.confirmClicked().then(() => {
      handleLogout();
    });
  };

  useEffect(() => {
    linksRef.current = links ?? [];
    setIsLinksReady(!!links && links.length > 0);
  }, [links]);

  useEffect(() => {
    if (isLinksReady) {
      const currentPath = location.pathname;
      const matchedLink = linksRef.current.find((link) => link.path === currentPath);

      if (matchedLink) {
        setOpenMenu(matchedLink.category);
      }
    }
  }, [location.pathname, isLinksReady]);

  const dashboardCategory = categories?.find((category) => category.name === 'DASHBOARD');
  const title = preferenceData?.find((item) => item.preference_key === 'title')?.preference_value;
  const logo = preferenceData?.find((item) => item.preference_key === 'nav_logo')?.preference_value;

  return (
    <>
      <section className="sticky top-0 h-screen w-[280px] shrink-0 border-r border-db-border bg-db-card">
        <div className="h-full overflow-y-auto px-5 py-6">
          <div className="space-y-2">
            {categories
              ?.filter((category) => category.name !== 'DASHBOARD')
              .map((category) => {
                const isOpen = openMenu === category.name;

                return (
                  <div key={category.name} className="rounded-lg overflow-hidden">
                    <button
                      type="button"
                      onClick={() => toggleVisibility(category.name)}
                      className={cn(
                        'flex w-full  items-center justify-between rounded-lg px-4 py-3 transition-colors',
                        isOpen
                          ? 'bg-[#135A78] text-white'
                          : 'text-text-blue-new dark:text-white hover:bg-db-dropdown'
                      )}
                    >
                      <span className="title2bold">{category.label}</span>

                      <img
                        src={dropdownArrow}
                        alt=""
                        className={cn(
                          'h-4 w-4 transition-transform duration-300 dark:invert-100 dark:brightness-100 ',
                          isOpen && 'rotate-180 invert-100'
                        )}
                      />
                    </button>

                    {/* <div
                      className={cn(
                        'grid transition-all duration-300',
                        isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
                      )}
                    >
                      <div className="ml-4 flex flex-col gap-1 border-l border-db-border pl-4">
                        {links
                          ?.filter((link) => link.category === category.name)
                          .map((link) => (
                            <NavLink
                              key={link.id}
                              to={link.path ?? ''}
                              className={({ isActive }) =>
                                cn(
                                  'rounded-md px-3 py-2 title2medium transition-colors',
                                  isActive
                                    ? 'bg-db-dropdown text-blue-new'
                                    : 'text-text-blue-new dark:text-white/80 '
                                )
                              }
                            >
                              {link.label}
                            </NavLink>
                          ))}
                      </div>
                    </div> */}

                    <motion.div
                      initial={false}
                      animate={{
                        height: isOpen ? 'auto' : 0,
                        opacity: isOpen ? 1 : 0,
                      }}
                      transition={{ duration: 0.25 }}
                      className="overflow-hidden"
                    >
                      <div className="ml-4 pt-2 flex flex-col gap-1 border-l border-db-border pl-4">
                        {links
                          ?.filter((link) => link.category === category.name)
                          .map((link) => (
                            <NavLink
                              key={link.id}
                              to={link.path ?? ''}
                              className={({ isActive }) =>
                                cn(
                                  'rounded-md px-3 py-2 title2medium transition-colors',
                                  isActive
                                    ? 'bg-db-dropdown text-blue-new'
                                    : 'text-text-blue-new dark:text-white/80 '
                                )
                              }
                            >
                              {link.label}
                            </NavLink>
                          ))}
                      </div>
                    </motion.div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>
      {userInfo?.account_id && (
        <ModalProfileManagement
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          userInfo={userInfo as unknown as { account_id: string; [key: string]: any }}
          commonData={commonData}
        />
      )}
    </>
  );
};

export default Sidebar;
